export default {
  getPagination: (state) => {
    return {
      ...state.paging,
      totalRecords: state.paging.totalItemCount,
      totalPages: state.paging.pageCount,
      pageSize: state.configPaginated.pageSize,
    };
  },
  getFilteredPeriod: (state) => state.selectedPeriod || state.filteredPeriod,
  getVisitFilter: (state) => state.selectedVisitFilter,
};
